export const FRANCHISE_MENTION = "TVA non applicable, art. 293 B du CGI";
export const CANADA_B2B_MENTION = "TVA non applicable en France, art. 259-1 du CGI";

export function fiscalPreview(client, params) {
  if (!client.type_client || client.type_client === "a_confirmer") return "Qualifiez la nature du client avant émission.";
  if (params?.regime_fiscal === "a_valider" || params?.tva_non_applicable === false || client.regime_tva === "a_valider") return "Régime fiscal à valider avant émission.";
  if (client.regime_tva === "franchise_base") return FRANCHISE_MENTION;
  if (client.pays === "Canada") return client.type_client === "professionnel" ? CANADA_B2B_MENTION : "Qualifiez le client et choisissez un régime validé avant émission.";
  return FRANCHISE_MENTION;
}

export function compatiblePrestations(prestations, devise) {
  return devise ? prestations.filter((line) => (line.devise || "EUR") === devise) : [];
}
